module.exports = __webpack_public_path__ + "f4b8453900a7d7e86e61e2f335c03f0d.png";